import React, { useState, useEffect } from "react";
import styles from "./trackingOverlay.module.scss";
import StatusBanner from "../statusBanner";
import { isStage } from "../../../config";

const REFRESHED_TICK_INTERVAL = 30 * 1000;

const changeBooking = id => {
  const currentParams = new URLSearchParams(window.location.search);

  let url = isStage
    ? `https://testtracker.zingmobility.com/customerTracking/${id}`
    : `https://tracer.zingbus.com/customerTracking/${id}`;

  currentParams.forEach((value, key) => {
    url += `${url.includes("?") ? "&" : "?"}${key}=${value}`;
  });

  window.location.replace(url);
};

const getRefreshedLabel = lastRefreshedAt => {
  if (!lastRefreshedAt) {
    return "Pull down to update.";
  }

  const minutes = Math.floor((Date.now() - lastRefreshedAt) / (60 * 1000));

  if (minutes < 1) {
    return "Last refreshed just now. Pull down to update.";
  }

  return `Last refreshed ${formatDuration(minutes)} ago. Pull down to update.`;
};

const formatDuration = totalMinutes => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const minLabel = `${minutes} min${minutes === 1 ? "" : "s"}`;

  if (hours < 1) {
    return minLabel;
  }

  const hourLabel = `${hours} hr${hours === 1 ? "" : "s"}`;
  return minutes ? `${hourLabel} ${minLabel}` : hourLabel;
};

const legLabel = (from, to) => `${from} to ${to}`;

const TrackingOverlay = props => {
  const { booking, lastRefreshedAt, lastDataRecievedAt, tripStatus } = props;
  // Re-render on a timer so the label keeps ageing even when the GPS feed
  // goes quiet and nothing else triggers an update.
  const [, setTick] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setTick(current => current + 1),
      REFRESHED_TICK_INTERVAL
    );

    return () => clearInterval(timer);
  }, []);

  const isMaxService = booking?.trip?.service?.isMaxService;
  const isFirstLegSelected = booking.connectingLegType === "FIRSTLEG";
  // Only a running trip has a location feed worth refreshing.
  const showRefreshedLabel = tripStatus === "ONTRIP";

  const currentLeg = legLabel(
    booking.boardingPoint.city,
    booking.dropPoint.city
  );
  const otherLeg = booking.connectingBooking
    ? legLabel(
        booking.connectingBooking.fromCity.name,
        booking.connectingBooking.toCity.name
      )
    : null;

  const showLegToggle = !!booking.connectingBookingCode && !!otherLeg;

  return (
    <>
      {showRefreshedLabel || showLegToggle ? (
        <div className={isMaxService ? styles.overlayMaxx : styles.overlay}>
          {showRefreshedLabel ? (
            <span className={styles.refreshed}>
              {getRefreshedLabel(
                parseInt(lastDataRecievedAt, 10) || lastRefreshedAt
              )}
            </span>
          ) : null}
          {showLegToggle ? (
            <div className={styles.toggle}>
              <button
                className={
                  isFirstLegSelected ? styles.selected : styles.unselected
                }
                onClick={
                  isFirstLegSelected
                    ? null
                    : () => changeBooking(booking.connectingBooking._id)
                }
              >
                {isFirstLegSelected ? currentLeg : otherLeg}
              </button>
              <button
                className={
                  isFirstLegSelected ? styles.unselected : styles.selected
                }
                onClick={
                  isFirstLegSelected
                    ? () => changeBooking(booking.connectingBooking._id)
                    : null
                }
              >
                {isFirstLegSelected ? otherLeg : currentLeg}
              </button>
            </div>
          ) : null}
        </div>
      ) : null}

      {booking?.trip?.service?.cabServiceType ? null : (
        <div className={styles.bottomOverlay}>
          <StatusBanner
            booking={booking}
            isMaxService={isMaxService}
            tripStatus={props.tripStatus}
            eta={props.eta}
            upcomingStation={props.upcomingStation}
            lastlocation={props.lastlocation}
            lastDataRecievedAt={props.lastDataRecievedAt}
            isTrackingWorking={props.isTrackingWorking}
            boardingStationMarked={props.boardingStationMarked}
          />
        </div>
      )}
    </>
  );
};

export default TrackingOverlay;
